import {classNames} from 'utils';
import styles from './cta.module.css';

export const DreamCTA = () => {
  return (
    <div className={classNames([styles.cta, styles.dream])}>
      <div className={styles.message}>Land Your Dream Job</div>
      <div className={styles.submessage}>
        Ace your interview and land your dream data job in data science, analytics, and machine
        learning.
      </div>
      <div className={styles.image}>
        <img src='/img/dream.svg' alt='background image' />
      </div>
    </div>
  );
};

export const MachineCTA = () => {
  return (
    <div className={classNames([styles.cta, styles.machine])}>
      <div className={styles.message}>Crack the Data Science Interview</div>
      <div className={styles.submessage}>
        Learn how to solve data science interview questions by practicing questions each week.
      </div>
      <div className={styles.image}>
        <img src='/img/machine.svg' alt='background image' />
      </div>
    </div>
  );
};
